import React from 'react'
import { Avatar, Dropdown } from 'components/ui'
import withHeaderItem from 'utils/hoc/withHeaderItem'
// import useAuth from 'utils/hooks/useAuth'
import { useDispatch, useSelector } from 'react-redux'
import { Link, useNavigate } from 'react-router-dom'
import classNames from 'classnames'
import { HiOutlineUser, HiOutlineLogout } from 'react-icons/hi'
import { userLoggedOut } from 'store/auth/userSlice'
import useApp from 'utils/hooks/useApp'
import { clearUserAnalyticsDataIntoStore } from 'store/extension/extensionUserAnalyticsSlice'
import { setAppInstance } from 'store/data-wallet-app/appInstanceSlice'
import { logout } from 'views/auth/utils'

const dropdownItemList = []

export const UserDropdown = ({ className }) => {
    const { app } = useApp()
    // bind this
    const user = useSelector((state) => state.auth.user)
    const lang = useSelector((state) => state.locale.currentLang)
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const signOut = async () => {
        try {
            // app.currentUser && (await app.currentUser.refreshCustomData())
            // app.currentUser && (await app.currentUser.logOut())
            const { newAppInstance } = await logout(app)

            // Updating app obj in local storage
            dispatch(setAppInstance(newAppInstance))

            // app.currentUser && dispatch(clearUserAnalyticsDataIntoStore())
            !app.currentUser && dispatch(userLoggedOut())
            !app.currentUser && navigate(`/${lang}/home`)
        } catch (error) {
            console.log(error)
        }
    }

    const UserAvatar = (
        <div className={classNames(className, 'flex items-center gap-2')}>
            <Avatar size={32} shape="circle" icon={<HiOutlineUser />} />
            <div className="hidden md:block">
                <div className="text-xs capitalize">{user?.name}</div>
                <div className="font-bold">User</div>
            </div>
        </div>
    )

    return (
        <div>
            <Dropdown
                menuStyle={{ minWidth: 240 }}
                renderTitle={UserAvatar}
                placement="bottom-end"
            >
                <Dropdown.Item variant="header">
                    <div className="py-2 px-3 flex items-center gap-2">
                        <Avatar shape="circle" icon={<HiOutlineUser />} />
                        <div>
                            <div className="font-bold text-gray-900 dark:text-gray-100">
                                {user?.name}
                            </div>
                            <div className="text-xs">{user?.email}</div>
                        </div>
                    </div>
                </Dropdown.Item>
                <Dropdown.Item variant="divider" />
                {dropdownItemList.map((item) => (
                    <Dropdown.Item
                        eventKey={item.label}
                        key={item.label}
                        className="mb-1"
                    >
                        <Link
                            className="flex gap-2 items-center"
                            to={item.path}
                        >
                            <span className="text-xl opacity-50">
                                {item.icon}
                            </span>
                            <span>{item.label}</span>
                        </Link>
                    </Dropdown.Item>
                ))}
                {/* <Dropdown.Item variant="divider" /> */}
                <Dropdown.Item
                    onClick={signOut}
                    eventKey="Sign Out"
                    className="gap-2"
                >
                    <span className="text-xl opacity-50">
                        <HiOutlineLogout />
                    </span>
                    <span>Sign Out</span>
                </Dropdown.Item>
            </Dropdown>
        </div>
    )
}

export default withHeaderItem(UserDropdown)
